/// Menu
import MetisMenu from "metismenujs";
import React, { Component, useContext, useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';
/// Scroll
import PerfectScrollbar from "react-perfect-scrollbar";
/// Link
import { Link } from "react-router-dom";
import useScrollPosition from "use-scroll-position";
import { ThemeContext } from "../../../context/ThemeContext";
import book from "../../../images/book.png";
class MM extends Component {
  componentDidMount() {
    this.$el = this.el;
    this.mm = new MetisMenu(this.$el);
  }
  componentWillUnmount() {
    //  this.mm("dispose");
    // console.log(this.mm);
  }
  render() {
    return (
      <div className="mm-wrapper">
        <ul className="metismenu" ref={(el) => (this.el = el)}>
          {this.props.children}
        </ul>
      </div>
    );
  }
}

const SideBar = () => {
  const { t } = useTranslation();
  const [projectitems, setProjects] = useState([]);

  const fetchProjects = async () => {
    try {
      const res = await fetch(
        "https://promaster.areez.co/api/projects/list",
         {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("user")}`,
                "Content-Type": "application/json",
            },
        }
      );
      const data = await res.json();
      setProjects(data.projects);
    } catch (err) {
      console.error("فشل في جلب الكليات", err);
    }
  };

  const { iconHover, sidebarposition, headerposition, sidebarLayout } =
    useContext(ThemeContext);
  useEffect(() => {
    fetchProjects();
    var btn = document.querySelector(".nav-control");
    var aaa = document.querySelector("#main-wrapper");
    function toggleFunc() {
      return aaa.classList.toggle("menu-toggle");
    }
    btn.addEventListener("click", toggleFunc);
  }, []);
  let scrollPosition = useScrollPosition();
  /// Path
  let path = window.location.pathname;
  path = path.split("/");
  path = path[path.length - 1];

  let fullPath = window.location.pathname;
  const isProjectsActive = fullPath.includes("/projects");
  const isCollegesActive = fullPath.includes("/colleges");
  /// Active menu
  

  return (
    
    <div
  
      className={`deznav ${iconHover} ${
        sidebarposition.value === "fixed" &&
        sidebarLayout.value === "horizontal" &&
        headerposition.value === "static"
          ? scrollPosition > 120
            ? "fixed"
            : ""
          : ""
      }`}
    >
<PerfectScrollbar className="deznav-scroll mt-5">
        <MM className="metismenu" id="menu">
          <li className={`${path === "" ? "mm-active" : ""}`}>
            <Link to="/">
              <i className="flaticon-381-home"></i>
              <span className="nav-text">{t("Dashboard")}</span>
            </Link>
          </li>

          <li className={`${isProjectsActive ? "mm-active" : ""}`}>
            <Link className="has-arrow ai-icon" to="#" aria-expanded="false">
              <i className="flaticon-381-networking"></i>
              <span className="nav-text">{t("Projects")}</span>
            </Link>
            <ul aria-expanded="false">
              {projectitems.map((p) => (
                <li key={p.id}>
                  <Link to={`/projects/detailes/${p.project_id}`}>
                    {p.project_name} - {p.company_name}
                  </Link>
                </li>
              ))}
            </ul>
          </li>
        </MM>
      </PerfectScrollbar>
    </div>
  );
};

export default SideBar;
